import { toast } from "sonner";
import { errorMessage } from "../../lib/api";

const LABEL = "font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500";
const CONTROL = "mt-1.5 w-full px-3 border border-slate-300 bg-white text-slate-900 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 disabled:bg-slate-50";

export const Card = ({ title, actions, children, className = "", testid }) => (
  <section className={`panel ${className}`} data-testid={testid}>
    {(title || actions) && (
      <header className="flex flex-wrap items-center justify-between gap-3 px-5 py-4 border-b border-slate-200">
        <h3 className="font-display font-bold uppercase tracking-wide text-slate-900 text-lg">{title}</h3>
        <div className="flex flex-wrap gap-2">{actions}</div>
      </header>
    )}
    <div className="p-5">{children}</div>
  </section>
);

export const KV = ({ k, v, testid }) => (
  <div className="py-2 grid grid-cols-3 gap-3 text-sm border-b border-slate-100 last:border-0">
    <dt className="text-slate-500">{k}</dt>
    <dd className="col-span-2 text-slate-900 break-words" data-testid={testid}>{v === null || v === undefined || v === "" ? "—" : v}</dd>
  </div>
);

export const TextInput = ({ label, value, onChange, testid, type = "text", className = "", ...rest }) => (
  <label className={`block ${className}`}>
    <span className={LABEL}>{label}</span>
    <input type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={`${CONTROL} h-10`} {...rest} />
  </label>
);

export const TextArea = ({ label, value, onChange, testid, rows = 3, className = "", ...rest }) => (
  <label className={`block ${className}`}>
    <span className={LABEL}>{label}</span>
    <textarea rows={rows} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={`${CONTROL} py-2`} {...rest} />
  </label>
);

export const SelectInput = ({ label, value, onChange, options, testid, className = "" }) => (
  <label className={`block ${className}`}>
    <span className={LABEL}>{label}</span>
    <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={`${CONTROL} h-10`}>
      {options.map((o) => <option key={o.value} value={o.value} disabled={o.disabled}>{o.label}</option>)}
    </select>
  </label>
);

export const CheckInput = ({ label, checked, onChange, testid, className = "" }) => (
  <label className={`flex items-center gap-2.5 text-sm text-slate-800 cursor-pointer ${className}`}>
    <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} className="w-4 h-4 accent-amber-500" />
    {label}
  </label>
);

export const Btn = ({ variant = "amber", className = "", children, ...rest }) => (
  <button type="button" className={`${variant === "amber" ? "btn-amber" : variant === "danger" ? "btn-ghost !border-red-300 !text-red-700 hover:!bg-red-50" : "btn-ghost"} h-10 px-4 text-sm disabled:opacity-50 disabled:pointer-events-none ${className}`} {...rest}>
    {children}
  </button>
);

export const PageTitle = ({ eyebrow, title, actions, testid }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8" data-testid={testid}>
    <div>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h1 className="mt-2 font-display font-black uppercase text-slate-900 text-3xl sm:text-4xl leading-none">{title}</h1>
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const emailToast = (res) => {
  if (!res) return;
  if (res.status === "sent") toast.success(`Email sent to ${res.to}`);
  else toast.warning(`Email failed: ${res.error || "unknown error"}`);
};

export const run = async (fn, okMsg) => {
  try {
    const r = await fn();
    if (okMsg) toast.success(okMsg);
    return r;
  } catch (e) {
    toast.error(errorMessage(e));
    return null;
  }
};

export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "—");
